module.exports = __webpack_public_path__ + "ar.svg?4da4346a31a123aa38c5c5ccd1e8e8c8";